<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.titles.signatures.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.signatures.signatureReject.title') }}
    </h2>
    <p>
      {{ $t('documentation.texts.signatures.signatureReject.paragraph1') }}
    </p>
    <v-img style="width: 100%; max-width: 600px" contain :src="picRejectForm" />
    <p>
      {{ $t('documentation.texts.signatures.signatureReject.paragraph2') }}
    </p>
    <v-img
      style="width: 100%; max-width: 600px"
      contain
      :src="picRejectPopUp"
    />
  </v-col>
</template>

<script>
export default {
  computed: {
    picRejectForm() {
      return require('@/assets/documentation/signatures/' +
        this.$t(
          'documentation.texts.signatures.signatureReject.picRejectForm'
        ) +
        '.png')
    },
    picRejectPopUp() {
      return require('@/assets/documentation/signatures/' +
        this.$t(
          'documentation.texts.signatures.signatureReject.picRejectPopUp'
        ) +
        '.png')
    },
  },
  methods: {},
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
